import React, { Component } from 'react';
import { Container, Row, Breadcrumb, BreadcrumbItem } from 'reactstrap';
import { Route, Routes, Navigate, Link } from "react-router-dom";
import MyTasksComponent from '../Tasks/index';
import TaskDetails from '../TaskDetails/index';
import { getPageTitle } from './constants';
import withRouter from '../../withRouter';
// import BillingComponent from '../Billing/index';

const MyTasksComponentwithRouter = withRouter(MyTasksComponent);
const TaskDetailswithRouter = withRouter(TaskDetails);

class Main extends Component {
    render() {
        let pageTitle = getPageTitle(this.props.location.pathname);
        return (
            <main className="app-main">
                <Container fluid className="px-0">
                    <Breadcrumb className="mb-3">
                        <BreadcrumbItem><Link to="/"> My Cases </Link></BreadcrumbItem>
                        <BreadcrumbItem active>{pageTitle}</BreadcrumbItem>
                    </Breadcrumb>
                    <Row>
                        {/*<Correspondent/>*/}
                        <Routes>
                            <Route exact path="/"  element={<Navigate to='/my-tasks' />} />
                            <Route exact path="/my-tasks" element={<MyTasksComponentwithRouter {...this.props}/>} component={MyTasksComponent} />
                            <Route exact path="/my-tasks/taskdetails/:caseId" element={<TaskDetailswithRouter {...this.props}/>} component={TaskDetails} />
                            {/* <Route exact path="/billing" component={BillingComponent} /> */}
                        </Routes>
                    </Row>
                </Container>
            </main>
        );
    }
}

export default withRouter(Main);